module.exports = ".divButton {\n    display: table;\n    text-align: left;\n    margin-top: 25px;\n    margin-bottom: 0;\n}\n\n.optionButton {\n    display: table-cell;\n    vertical-align: bottom;\n    height: 30px;\n}\n\n.rowBorder {\n    border: 1px double rgba(211, 211, 211, 0.12);\n    background: rgba(211, 211, 211, 0.12);\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/vehicles/vehicle.editor.component.css
 ** module id = 937
 ** module chunks = 0
 **/